// src/data/universities.js

// 🔹 Full list (moved out from Dashboard)
export const UNIVERSITIES = [
  {
    name: "University of Texas at Arlington",
    city: "Arlington",
    state: "Texas",
    acceptanceRate: "81%",
    annualTuitionUSD: 29582,
    avgLivingCostUSD: 16000,
    websiteURL: "https://www.uta.edu/admissions/international-undergraduate",
    minGPA: 2.75,
    minTOEFL: 79,
    minIELTS: 6.5,
    minDuolingo: 105,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: true,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "University of Colorado Boulder",
    city: "Boulder",
    state: "Colorado",
    acceptanceRate: "81%",
    annualTuitionUSD: 43622,
    avgLivingCostUSD: 15972,
    websiteURL: "https://www.colorado.edu/admissions/international",
    minGPA: 3.0,
    minTOEFL: 72,
    minIELTS: 6.5,
    minDuolingo: 105,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: true,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "University of Cincinnati",
    city: "Cincinnati",
    state: "Ohio",
    acceptanceRate: "69%",
    annualTuitionUSD: 20000,
    avgLivingCostUSD: 16000,
    websiteURL: "https://admissions.uc.edu/information/international/requirements.html",
    minGPA: 3.0,
    minTOEFL: 80,
    minIELTS: 6.5,
    minDuolingo: 110,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: true,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Indiana University Bloomington",
    city: "Bloomington",
    state: "Indiana",
    acceptanceRate: "82%",
    annualTuitionUSD: 56000,
    avgLivingCostUSD: 18000,
    websiteURL: "https://ois.iu.edu/admissions/index.html",
    minGPA: 3.3,
    minTOEFL: 80,
    minIELTS: 6.5,
    minDuolingo: 0,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: true,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Pace University",
    city: "New York",
    state: "New York",
    acceptanceRate: "83%",
    annualTuitionUSD: 53290,
    avgLivingCostUSD: 30000,
    websiteURL: "https://www.pace.edu/admission-and-aid/international-admission",
    minGPA: 3.0,
    minTOEFL: 78,
    minIELTS: 6.5,
    minDuolingo: 105,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: true,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Kent State University",
    city: "Kent",
    state: "Ohio",
    acceptanceRate: "88%",
    annualTuitionUSD: 23690,
    avgLivingCostUSD: 19384,
    websiteURL: "https://www.kent.edu/admissions/international-first-year-student-requirements",
    minGPA: 2.5,
    minTOEFL: 71,
    minIELTS: 6.0,
    minDuolingo: 100,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: true,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },

  // ...you can paste the rest of your dashboard list here unchanged...
];

// src/pages/universities.js

export const FEATURED_UNIVERSITIES = [
  {
    name: "University of Texas at Arlington",
    city: "Arlington, Texas",
    websiteURL: "https://www.uta.edu/admissions/international-undergraduate",
    logoFile: "assets/images/texas.png"
  },
  {
    name: "University of Colorado Boulder",
    city: "Boulder, Colorado",
    websiteURL: "https://www.colorado.edu/admissions/international",
    logoFile: "assets/images/boular.png" // ✅ no "/public"
  },
  {
    name: "University of Cincinnati",
    city: "Cincinnati, Ohio",
    websiteURL: "https://admissions.uc.edu/information/international/requirements.html",
    logoFile: "assets/images/cincinnati.webp"
  }
];
